import { errCodes } from "./errors";

function createApiResponse(data = {}, isSuccess = false, error = {}, errCode = "") {
  if (isSuccess === false && errCode === "") errCode = errCodes.Internal;

  return {
    data: data,
    success: isSuccess,
    error: error,
    code: errCode,
  };
}

const Response = {
  create: createApiResponse,
};

export default Response;
